export function getUrlParams(name) {
  let url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function setParamToUrl(url, paramName, value) {
  let param = getUrlParams(paramName);
  if(param) {
    url.searchParams.delete(paramName);
    param = `${param};${value}`
    url.searchParams.append(paramName, param);
  } else {
    url.searchParams.append(paramName, value);
  }
}

export function removeValueOfParamToUrl(url, paramName, removeValue) {
  let oldParams = getUrlParams(paramName),
  newParams = oldParams.split(';').filter(e => e !== removeValue).join(';');
  url.searchParams.delete(paramName);
  if(newParams !== '') {
    url.searchParams.append(paramName, newParams);
  }
}
